import { render } from "./Sheet.vue?vue&type=template&id=056a7874"
import script from "./Sheet.vue?vue&type=script&lang=js"
export * from "./Sheet.vue?vue&type=script&lang=js"

import "./Sheet.vue?vue&type=style&index=0&id=056a7874&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__